import { useRecoilValue } from 'recoil';

import * as K from 'common/constants';
import { isLabEnabledState } from 'components/account/account.state';

export const useIsLabEnabled = (lab: K.LAB) => useRecoilValue(isLabEnabledState(lab));
